import { postRequest } from "../libs/AxiosService.util";

export async function serviceCreateDoctor(params) {
  return await postRequest("doctors/create", params);
}

export async function serviceUpdateDoctor(params) {
  return await postRequest("doctors/update", params);
}

export async function serviceDeleteDoctor(params) {
  return await postRequest("doctors/delete", params);
}

export async function serviceGetDoctor(params) {
  return await postRequest("doctors", params);
}

export async function serviceIsDoctorExist(params) {
  return await postRequest("doctors/check", params);
}

export async function serviceGetDoctorDetails(params) {
  return await postRequest("doctors/detail", params);
}
